// this is an autogenerated file from DesignSystem/ImageViewer/PatientImages/Preview/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_ImageViewer_PatientImages_Preview($resource_id: StringOrNumber!) {
  vaxiom_resource_object_meta(resource_id: $resource_id, resource_type: image) {
    preview_url
  }
}

`